const AboutMe = () => {
  const containerStyle = {
    color: "#FFFFFF",
    fontFamily: "Roboto, Arial, sans-serif",
    padding: "40px",
    lineHeight: "1.8",
    maxWidth: "900px",
    background: "linear-gradient(to bottom, #101010, #1c1c1c, #292929, #363636, #424242)",
    boxShadow: "0 10px 30px rgba(0, 0, 0, 0.2)",
    borderRadius: "15px",
    margin: "20px auto",
  };

  const headingStyle = {
    fontSize: "2.5rem",
    borderBottom: "2px solid #00B4D8",
    paddingBottom: "15px",
    marginBottom: "30px",
    textShadow: "1px 1px 3px rgba(0, 0, 0, 0.2)",
  };

  const introductionStyle = {
    fontSize: "1.2rem",
    marginBottom: "25px",
    lineHeight: "1.6",
  };

  const sectionTitleStyle = {
    fontSize: "1.8rem",
    borderBottom: "1px solid #00B4D8",
    paddingBottom: "10px",
    marginBottom: "20px",
    color: "#00B4D8",
  };

  const skillCategoryStyle = {
    fontSize: "1.4rem",
    color: "#FFD700",
    marginBottom: "15px",
    fontWeight: "600",
  };

  const skillItemStyle = {
    fontSize: "1.1rem",
    marginBottom: "10px",
    padding: "10px",
    background: "rgba(0, 180, 216, 0.1)",
    borderRadius: "8px",
  };

  const technicalSkills = [
    { category: "Full-Stack Development", skills: ["React, Next.js, React Native, HTML, CSS, Javascript", "Node.js, Golang, Strapi", "RESTful APIs"] },
    { category: "Backend & Systems", skills: ["C++, C#, Python", "Embedded Systems", "DevOps & Deployment"] },
    { category: "Databases & AI", skills: ["SQL, NoSQL", "AI Models, ML Libraries"] },
    { category: "Workflow & Tools", skills: ["Git & Version Control", "Agile, Scrum, Kanban"] },
  ];

  return (
    <div style={containerStyle}>
      <h1 style={headingStyle}>About Me</h1>

      <p style={introductionStyle}>
        I'm a passionate IT graduate developer with a strong focus on full-stack development. I thrive on solving complex problems and building scalable solutions, blending technical precision with creative thinking. My journey spans diverse technologies and collaborative team projects, with a core interest in backend systems and architecture.
      </p>

      <div style={{ marginBottom: "30px" }}>
        <h2 style={sectionTitleStyle}>Professional Background</h2>
        <ul style={{ listStyle: "none", padding: 0 }}>
          <li style={skillItemStyle}>Originally from Pakistan, currently based in Dunedin, New Zealand</li>
          <li style={skillItemStyle}>Experienced in leading and contributing to team projects</li>
          <li style={skillItemStyle}>Passionate about design, technology, and learning new things</li>
        </ul>
      </div>

      <div style={{ marginBottom: "30px" }}>
        <h2 style={sectionTitleStyle}>Technical Expertise</h2>
        {technicalSkills.map((category) => (
          <div key={category.category} style={{ marginBottom: "25px" }}>
            <h3 style={skillCategoryStyle}>{category.category}</h3>
            <ul style={{ listStyle: "none", padding: 0 }}>
              {category.skills.map((skill) => (
                <li key={skill} style={skillItemStyle}>{skill}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div style={{ marginBottom: "30px" }}>
        <h2 style={sectionTitleStyle}>Certifications</h2>
        <ul style={{ listStyle: "none", padding: 0 }}>
          <li style={skillItemStyle}>Upper-Intermediate English Business, Polytechnic University of Valencia (EDX, 2020)</li>
          <li style={skillItemStyle}>Cisco IT Essentials, Otago Polytechnic (2021)</li>
          <li style={skillItemStyle}>Letter of Merit – Cisco IT Essentials (2021)</li>
        </ul>
      </div>

      <div>
        <h2 style={sectionTitleStyle}>Professional Skills</h2>
        <ul style={{ listStyle: "none", padding: 0 }}>
          <li style={skillItemStyle}>Clear communicator & active listener</li>
          <li style={skillItemStyle}>Creative and resourceful problem-solver</li>
          <li style={skillItemStyle}>Motivated, dependable, and quality-focused</li>
          <li style={skillItemStyle}>Strong team collaborator with leadership potential</li>
          <li style={skillItemStyle}>Adaptable to change and quick to learn</li>
          <li style={skillItemStyle}>Skilled at balancing multiple projects</li>
        </ul>
      </div>
    </div>
  );
};

export default AboutMe;